import { render, staticRenderFns } from "./RedBag.vue?vue&type=template&id=0e6a608a&scoped=true"
import script from "./RedBag.vue?vue&type=script&lang=js"
export * from "./RedBag.vue?vue&type=script&lang=js"
import style0 from "./RedBag.vue?vue&type=style&index=0&id=0e6a608a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a608a",
  null
  
)

export default component.exports